import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        await refresh();
        toast.success("Accesso effettuato");
        // Clean hash and go to check-up
        window.history.replaceState(null, "", window.location.pathname);
        nav("/quiz", { replace: true });
      } catch (e) {
        toast.error("Login fallito, riprova");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div data-testid="auth-callback" className="min-h-[60vh] flex items-center justify-center text-[#5A6058]">
      Accesso in corso…
    </div>
  );
}
